import { render, staticRenderFns } from "./ali-pay-form.vue?vue&type=template&id=4b2b3352&"
import script from "./ali-pay-form.vue?vue&type=script&lang=js&"
export * from "./ali-pay-form.vue?vue&type=script&lang=js&"
import style0 from "./ali-pay-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports